export default function AlmostReady() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4 rounded-3xl w-full  shadow-xl p-10 text-center font-inter">
      <div className="">
        {/* Illustration */}
        <div className="flex justify-center mb-8">
          <img
            src="/almost-ready.png"
            alt="Almost Ready"
            className="h-40 w-auto"
          />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-gray-900 mb-3">
          We’re Almost Ready
        </h2>

        {/* Description */}
        <p className="text-gray-600 max-w-md mx-auto mb-8">
          Due to a minor technical issue, your timeline is taking a little
          longer than expected.
        </p>

        {/* Button */}
        <button
          onClick={() => window.location.reload()}
          className="bg-[#572575] hover:bg-purple-800 text-white font-medium px-8 py-3 rounded-xl transition"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
